const rankings = [
  { rank: 1, title: '狂飙', desc: '张颂文张译主演反黑刑侦大剧，全39集完整版', hot: '本周热度 98.6', trend: 'up' },
  { rank: 2, title: '漫长的季节', desc: '豆瓣9.4分国产悬疑巅峰，全12集全集在线', hot: '本周热度 96.2', trend: 'up' },
  { rank: 3, title: '繁花', desc: '王家卫首部电视剧，胡歌主演全30集高清', hot: '本周热度 93.8', trend: 'stable' },
  { rank: 4, title: '黑暗荣耀', desc: '宋慧乔复仇韩剧全两季共16集完整版', hot: '本周热度 91.5', trend: 'up' },
  { rank: 5, title: '琅琊榜', desc: '胡歌经典古装权谋剧，全54集高清修复版', hot: '本周热度 88.3', trend: 'stable' },
  { rank: 6, title: '庆余年第二季', desc: '张若昀回归主演，全36集大结局已上线', hot: '本周热度 86.7', trend: 'down' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">
              追剧榜单
            </h2>
            <p className="text-foreground-400 text-sm max-w-[500px] mx-auto">
              实时热度排行，看看大家都在追哪些电视剧全集
            </p>
          </div>

          <div className="max-w-[720px] mx-auto flex flex-col gap-3">
            {rankings.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 bg-background-200/70 rounded-lg p-4 border border-background-300/30 hover:border-primary-500/30 cursor-pointer transition-colors duration-200"
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center font-heading text-lg whitespace-nowrap ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-foreground-50'
                    : 'bg-background-300 text-foreground-300'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <h3 className="text-foreground-100 text-sm font-medium whitespace-nowrap">
                      {item.title}
                    </h3>
                    <i className={`text-xs ${
                      item.trend === 'up'
                        ? 'ri-arrow-up-line text-primary-400'
                        : item.trend === 'down'
                        ? 'ri-arrow-down-line text-foreground-500'
                        : 'ri-subtract-line text-foreground-500'
                    }`}></i>
                  </div>
                  <p className="text-foreground-500 text-xs truncate">{item.desc}</p>
                </div>

                <div className="text-right flex-shrink-0">
                  <span className="text-accent-400 text-sm font-medium whitespace-nowrap">
                    {item.hot}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}